import script from "./JobsView.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsView.vue?vue&type=script&setup=true&lang=js"

import "./JobsView.vue?vue&type=style&index=0&id=25b53aee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25b53aee"]])

export default __exports__